import TemplateView from '../../TemplateView'

export default class ImageRequirementsPopup extends TemplateView {
    constructor({
        showReportsSection = false,
    }) {
        super()

        this.params = {
            showReportsSection,
        }
    }

    templateHtml() {
        return '<div class="logoImageRequirementsPopup">' +
               '    <div class="interfacesSection">' +
               '        <div class="header"><%=interfacesHeader%></div>' +
               '        <ul>' +
               '            <li class="rule"><%=interfacesRule1%></li>' +
               '            <li class="rule"><%=interfacesRule2%></li>' +
               '            <li class="rule"><%=interfacesRule3%></li>' +
               '            <li class="note"><%=interfacesRule3Note%></li>' +
               '            <li class="rule"><%=interfacesRule4%></li>' +
               '            <li class="rule"><%=interfacesRule5%></li>' +
               '        </ul>' +
               '    </div> ' +
               '    <div class="reportsSection">' +
               '        <div class="header"><%=reportsHeader%></div>' +
               '        <ul>' +
               '            <li class="rule"><%=reportsRule1%></li>' +
               '            <li class="rule"><%=reportsRule2%></li>' +
               '            <li class="rule"><%=reportsRule3%></li>' +
               '        </ul>' +
               '    </div> ' +
               '</div>'
    }

    messageKeys() {
        return {
            interfacesHeader: 'logo_settings.image_requirements.interfaces.header',
            interfacesRule1: 'logo_settings.image_requirements.interfaces.rule1',
            interfacesRule2: 'logo_settings.image_requirements.interfaces.rule2',
            interfacesRule3: 'logo_settings.image_requirements.interfaces.rule3',
            interfacesRule3Note: 'logo_settings.image_requirements.interfaces.rule3_note',
            interfacesRule4: 'logo_settings.image_requirements.interfaces.rule4',
            interfacesRule5: 'logo_settings.image_requirements.interfaces.rule5',
            reportsHeader: 'logo_settings.image_requirements.reports.header',
            reportsRule1: 'logo_settings.image_requirements.reports.rule1',
            reportsRule2: 'logo_settings.image_requirements.reports.rule2',
            reportsRule3: 'logo_settings.image_requirements.reports.rule3',
        }
    }

    afterRender() {
        this.find('.reportsSection').toggle(this.params.showReportsSection)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/customization/ImageRequirementsPopup.js